import { render, staticRenderFns } from "./ReviewProposal.vue?vue&type=template&id=5e441b98&scoped=true&"
import script from "./ReviewProposal.vue?vue&type=script&lang=js&"
export * from "./ReviewProposal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProposal.vue?vue&type=style&index=0&id=5e441b98&prod&lang=css&"
import style1 from "./ReviewProposal.vue?vue&type=style&index=1&id=5e441b98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e441b98",
  null
  
)

export default component.exports